import React, { Component } from 'react';
import {
    Button,
    Col,
    Input,
    message,
    Row,
    Table,
    DatePicker,
    Divider,
} from 'antd';
import axios from 'axios';
import { Redirect, withRouter } from 'react-router-dom';
import moment from 'moment';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import Cookies from "js-cookie";

class BookingReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            bookings: [],
            searchText: '',
            dateRange: [null, null],
        };
    }

    componentDidMount() {
        this.getAllBookings();
    }

    async getAllBookings() {
        this.setState({ loading: true });
        try {
            const response = await axios.post('https://api.srilankaballooning.com/api/getAllBookings');
            if (response.data.success) {
                this.setState({ bookings: response.data.result });
            } else {
                message.error('Failed to fetch bookings.');
            }
        } catch (error) {
            console.error('Error fetching bookings:', error);
            message.error('Internal server error');
        } finally {
            this.setState({ loading: false });
        }
    }

    handleSearch = (e) => {
        this.setState({ searchText: e.target.value.toLowerCase() });
    };

    handleDateChange = (field, date) => {
        const newRange = [...this.state.dateRange];
        newRange[field === 'start' ? 0 : 1] = date;
        this.setState({ dateRange: newRange });
    };

    computeRowSpan(rows, columnKey, rowSpanKey) {
        const newRows = [...rows];
        let i = 0;
        while (i < newRows.length) {
            let count = 1;
            for (let j = i + 1; j < newRows.length; j++) {
                if (newRows[j][columnKey] === newRows[i][columnKey]) {
                    count++;
                } else {
                    break;
                }
            }
            newRows[i][rowSpanKey] = count;
            for (let k = i + 1; k < i + count; k++) {
                newRows[k][rowSpanKey] = 0;
            }
            i += count;
        }
        return newRows;
    }

    getFilteredBookings() {
        const { bookings, searchText, dateRange } = this.state;

        let filtered = bookings.filter((booking) => {
            if (searchText) {
                const pass = booking.PASSENGER_NAME?.toLowerCase().includes(searchText);
                const agent = booking.AGENT?.toLowerCase().includes(searchText);
                const tour = booking.TOUR_NO?.toLowerCase().includes(searchText);
                const hotel = booking.HOTEL?.toLowerCase().includes(searchText);
                if (!(pass || agent || tour || hotel)) {
                    return false;
                }
            }
            if (dateRange && dateRange[0]) {
                const bookingDate = moment(booking.DATE, "YYYY-MM-DD");
                if (!bookingDate.isSameOrAfter(dateRange[0].format("YYYY-MM-DD"), 'day')) return false;
                if (dateRange[1]?.format("YYYY-MM-DD") && !bookingDate.isSameOrBefore(dateRange[1].format("YYYY-MM-DD"), 'day')) return false;
            }
            return true;
        });

        filtered.sort((a, b) => {
            const dateA = moment(a.DATE, "YYYY-MM-DD");
            const dateB = moment(b.DATE, "YYYY-MM-DD");
            if (!dateA.isSame(dateB)) {
                return dateA.diff(dateB);
            }
            return (a.TOUR_NO || '').localeCompare(b.TOUR_NO || '');
        });

        filtered = this.computeRowSpan(filtered, 'DATE', 'dateRowSpan');
        filtered = this.computeRowSpan(filtered, 'TOUR_NO', 'tourRowSpan');

        const lightColors = ['group-color-1', 'group-color-2'];
        let currentDate = null;
        let lastIndex = -1;
        let groupIndex = 0;

        filtered.forEach((row) => {
            row.isFirstInGroup = false;
            row.isLastInGroup = false;
            row.groupColorClass = '';
        });

        for (let i = 0; i < filtered.length; i++) {
            if (filtered[i].DATE !== currentDate) {
                if (lastIndex >= 0) {
                    filtered[lastIndex].isLastInGroup = true;
                }
                currentDate = filtered[i].DATE;
                filtered[i].isFirstInGroup = true;
                groupIndex++;
            }
            filtered[i].groupColorClass = lightColors[groupIndex % lightColors.length];
            lastIndex = i;
        }

        if (lastIndex >= 0) {
            filtered[lastIndex].isLastInGroup = true;
        }

        return filtered;
    }

    handleExportPdf = () => {
        const { dateRange } = this.state;
        const filtered = this.getFilteredBookings();

        const doc = new jsPDF('p', 'pt', 'a4');

        doc.setFontSize(14);
        doc.text('Booking Report', 40, 40);

        if (dateRange && dateRange[0] && dateRange[1]) {
            doc.setFontSize(10);
            const fromDate = dateRange[0].format('YYYY-MM-DD');
            const toDate = dateRange[1].format('YYYY-MM-DD');
            doc.text(`From: ${fromDate}  To: ${toDate}`, 40, 60);
        } else {
            doc.setFontSize(10);
            doc.text('(No date range selected)', 40, 60);
        }

        const pdfRows = filtered.map(row => ([
            row.DATE || '',
            row.TOUR_NO || '',
            row.AGENT || '',
            row.PASSENGER_NAME || '',
            row.CONTACT || '',
            row.HOTEL || '',
            row.PAX_NO || '',
            row.REMARKS || '',
        ]));

        autoTable(doc, {
            startY: 70,
            head: [["Date", "Tour No", "Guide/Agent", "Passenger Name", "Contact", "Hotel", "Pax No", "Remarks"]],
            body: pdfRows,
            styles: { fontSize: 8, cellPadding: 4 },
            headStyles: { fillColor: [200, 200, 200] }
        });

        doc.save("BookingReport.pdf");
    };

    render() {
        let rememberedUser = Cookies.get('rememberedUser');
        let ROLE = null;
        if (rememberedUser) {
            rememberedUser = JSON.parse(rememberedUser);
            ROLE = rememberedUser.ROLE;
        }
        if (ROLE === 'USER_MILL') {
            return <Redirect to="/bookings" />;
        }

        const { loading, dateRange } = this.state;
        const filteredBookings = this.getFilteredBookings();

        const columns = [
            {
                title: 'Date',
                dataIndex: 'DATE',
                key: 'DATE',
                render: (text, row) => ({
                    children: text,
                    props: { rowSpan: row.dateRowSpan },
                }),
            },
            {
                title: 'Tour No',
                dataIndex: 'TOUR_NO',
                key: 'TOUR_NO',
                render: (text, row) => ({
                    children: text,
                    props: { rowSpan: row.tourRowSpan },
                }),
            },
            {
                title: 'Guide/Agent',
                dataIndex: 'AGENT',
                key: 'AGENT',
            },
            {
                title: 'Passenger Name',
                dataIndex: 'PASSENGER_NAME',
                key: 'PASSENGER_NAME',
            },
            {
                title: 'Contact',
                dataIndex: 'CONTACT',
                key: 'CONTACT',
            },
            {
                title: 'Hotel',
                dataIndex: 'HOTEL',
                key: 'HOTEL',
            },
            {
                title: 'Pax No',
                dataIndex: 'PAX_NO',
                key: 'PAX_NO',
            },
            {
                title: 'Remarks',
                dataIndex: 'REMARKS',
                key: 'REMARKS',
            },
        ];

        return (
            <div className="tabled" style={{ padding: '20px', overflowX: 'auto' }}>
                <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                    <Col xs={12} sm={6}>
                        <DatePicker
                            style={{ width: '100%' }}
                            placeholder="Start Date"
                            value={dateRange[0]}
                            onChange={(date) => this.handleDateChange('start', date)}
                            allowClear
                        />
                    </Col>
                    <Col xs={12} sm={6}>
                        <DatePicker
                            style={{ width: '100%' }}
                            placeholder="End Date"
                            value={dateRange[1]}
                            onChange={(date) => this.handleDateChange('end', date)}
                            allowClear
                        />
                    </Col>
                    <Col xs={24} sm={6}>
                        <Input
                            placeholder="Search by Passenger, Guide, Tour No, or Hotel"
                            onChange={this.handleSearch}
                            allowClear
                        />
                    </Col>
                    <Col xs={24} sm={6}>
                        <Button type="primary" onClick={this.handleExportPdf} style={{ width: '100%' }}>
                            Export PDF
                        </Button>
                    </Col>
                </Row>

                {loading ? (
                    <p>Loading bookings...</p>
                ) : filteredBookings.length === 0 ? (
                    <p>No bookings available for selected range.</p>
                ) : (
                    <Divider orientation="left" style={{ marginBottom: 10 }}>
                        Booking Report
                    </Divider>
                )}

                <Table
                    columns={columns}
                    dataSource={filteredBookings}
                    rowKey="BOOKING_ID"
                    pagination={false}
                    bordered
                    size="small"
                    scroll={{ x: 'max-content' }}
                    rowClassName={(record) => `first-group-row ${record.groupColorClass}`}
                />

                <style>{`
                    .first-group-row td {
                        padding-top: 10px !important;
                    }
                    .ant-table td {
                        padding-top: 4px;
                        padding-bottom: 4px;
                    }
                    .ant-table table {
                        border-collapse: separate !important;
                        border-spacing: 0px;
                    }
                    .group-color-1 td { background-color: #f0fff4; }
                    .group-color-2 td { background-color: #f0f9ff; }
                `}</style>
            </div>
        );
    }
}

export default withRouter(BookingReport);
